import React, { useEffect, useState } from "react";
import { EVENT, TICKET_URL } from "@/data/content";
import { scrollToId } from "@/lib/scroll";
import { trackTicketClick } from "@/lib/analytics";

const LINKS = [
  { id: "butiran", label: "Butiran" },
  { id: "poster", label: "Poster" },
  { id: "tiket", label: "Tiket" },
  { id: "faq", label: "Soalan Lazim" },
];

export default function Navbar() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className={`nav ${solid ? "nav--solid" : ""}`} data-testid="navbar">
      <div className="nav__inner">
        <button
          className="nav__brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-brand"
        >
          <span className="nav__brand-sub">{EVENT.brand}</span>
          <span className="nav__brand-main">{EVENT.title}</span>
        </button>

        <nav className="nav__links">
          {LINKS.map((l) => (
            <button
              key={l.id}
              className="nav__link"
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="nav__right">
          <span className="nav__date">{EVENT.dateShort}</span>
          <a
            className="btn btn--gold btn--sm"
            href={TICKET_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackTicketClick("nav")}
            data-testid="nav-cta-tiket"
          >
            BELI TIKET
          </a>
          <button
            className="nav__burger"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-burger"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {open && (
        <div className="nav__mobile" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
